// Typelizer digest 3765c2f731cfa42bc336a4ad1319bf26
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** POST /team/members/:member_id/reactivation */
  create: (
    params: { memberId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/team/members/:member_id/reactivation', params, options),
    method: 'post',
  }),
}
